// Adaptateur unique : le moteur backend est l'unique source de vérité des projets MOE.
import { useEngine } from "./store";
import { weightedProgress } from "./model";

export const nextStepOf = (p) => {
  if (p.progressDeclarations.some((d) => d.status === "a_verifier")) return "Valider un avancement déclaré";
  if (p.invoices.some((i) => i.status === "a_verifier")) return "Contrôler une facture / situation";
  if (p.quotes.some((q) => ["depose", "a_examiner"].includes(q.status))) return "Examiner un devis";
  return "Suivi de chantier";
};

export const fromEngine = (p) => ({
  ref: p.ref, name: p.name, client: p.client.name, clientId: p.client.id, address: p.address, phase: p.phase,
  projectType: p.projectType,
  budget: p.lots.reduce((s, l) => s + l.amountHT, 0), nextStep: nextStepOf(p), nextMeeting: p.nextMeeting || "—",
  pros: [...new Set(p.lots.filter((l) => l.companyId).map((l) => l.companyId))], progress: weightedProgress(p), engine: true,
});

export const useProjects = () => {
  const engine = useEngine();
  return Object.values(engine.state.projects).map(fromEngine);
};
